import { render, staticRenderFns } from "./UiDataInput.vue?vue&type=template&id=205780c2&scoped=true"
import script from "./UiDataInput.vue?vue&type=script&lang=js"
export * from "./UiDataInput.vue?vue&type=script&lang=js"
import style0 from "./UiDataInput.vue?vue&type=style&index=0&id=205780c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205780c2",
  null
  
)

export default component.exports